import { FunctionComponent, useEffect } from 'react';
import { Stack, FormControl, InputLabel, OutlinedInput, FormHelperText } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { DialogWrapper } from '../../presentation-components/display-elements-components/dialog-wrapper';
import { IFriendlyCategoryGroup, IPostFriendlyCategoryGroup } from '../../../shared/services/super-admin/super-admin.service';

export const AddEditFriendlyCategoryGroupDialog: FunctionComponent<{
  open: boolean;
  closeHandler: () => void;
  isEdit: boolean;
  group?: IFriendlyCategoryGroup;
  isSubmitting: boolean;
  onSubmit: (values: IPostFriendlyCategoryGroup, resetForm: () => void, isEdit: boolean) => void;
}> = ({ open, closeHandler, isEdit, group, isSubmitting, onSubmit }) => {
  const schema = Yup.object().shape({
    name: Yup.string().trim().required('Name is required'),
    displayOrder: Yup.number().nullable(),
    icon: Yup.string().nullable(),
  });

  const formik = useFormik<IPostFriendlyCategoryGroup>({
    validationSchema: schema,
    enableReinitialize: false,
    initialValues: { name: '', displayOrder: 0, icon: '' },
    onSubmit: (values, { resetForm }) => {
      onSubmit(values, resetForm, isEdit);
    },
  });

  useEffect(() => {
    if (open && isEdit && group) {
      formik.setFieldValue('name', group.name);
      formik.setFieldValue('displayOrder', group.displayOrder ?? 0);
      formik.setFieldValue('icon', group.icon ?? '');
    } else if (!open) {
      formik.resetForm();
    }
  }, [open]);

  return (
    <DialogWrapper
      open={open}
      onClose={closeHandler}
      title={isEdit ? 'Edit Category Group' : 'Add Category Group'}
      cancelHandler={closeHandler}
      submitHandler={formik.submitForm}
      isSubmitting={isSubmitting}
      disableSaveButton={isSubmitting}
    >
      <Stack sx={{ mt: 1 }}>
        <FormControl fullWidth error={formik.touched.name && Boolean(formik.errors.name)}>
          <InputLabel htmlFor="name">Name</InputLabel>
          <OutlinedInput
            id="name"
            label="Name"
            value={formik.values.name || ''}
            onChange={(e) => formik.setFieldValue('name', e.target.value)}
          />
          <FormHelperText>
            {formik.touched.name && formik.errors.name ? formik.errors.name : ' '}
          </FormHelperText>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel htmlFor="displayOrder">Display Order</InputLabel>
          <OutlinedInput
            id="displayOrder"
            label="Display Order"
            type="number"
            value={formik.values.displayOrder ?? ''}
            onChange={(e) => formik.setFieldValue('displayOrder', parseInt(e.target.value) || 0)}
          />
          <FormHelperText> </FormHelperText>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel htmlFor="icon">Icon (MUI icon name)</InputLabel>
          <OutlinedInput
            id="icon"
            label="Icon (MUI icon name)"
            value={formik.values.icon || ''}
            onChange={(e) => formik.setFieldValue('icon', e.target.value)}
          />
          <FormHelperText> </FormHelperText>
        </FormControl>
      </Stack>
    </DialogWrapper>
  );
};
